import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import {
  Redirect
} from 'react-router-dom';
import  ReactMarkdown from 'react-markdown';

const Holding = ({page, onHoldingSubmit=f=>f, onCancelSubmit=f=>f, intl, territoryCode, content}) => {

    const { formatMessage } = intl;
    const thisPage = P.HOLDING_PAGE;
    const locationClass = String("location-icon location-icon-" + territoryCode.toLowerCase());

    const submit = e => {
        e.preventDefault();
        onHoldingSubmit();
      };

    const cancel = e => {
        e.preventDefault();
        onCancelSubmit();
        window.location = content.marketing_home_url
      };

    return (
      <div id={page}>
        <Redirector this_page={thisPage} page={page}/>
        <div className="text-center">
          <div className={locationClass}>
          </div>
      </div>
        <FormHeader title={content.pages.holding.title}/>
        <ReactMarkdown source={content.pages.holding.body} className='content-container'/>
        <form>
          <Button type="submit" onClick={cancel} className='pull-left'>
              <div>{formatMessage(defaultMessages.clientHostPagesHoldingButtonsCancelMain)}</div>
              <div className="small text-center">{formatMessage(defaultMessages.clientHostPagesHoldingButtonsCancelSub)}</div>
          </Button>
          <Button type="submit" onClick={submit} className='btn-primary pull-right' id='continue'>
              <div>{formatMessage(defaultMessages.clientHostPagesHoldingButtonsContinueMain)}</div>
              <div>{formatMessage(defaultMessages.clientHostPagesHoldingButtonsContinueSub)}</div>
          </Button>
        </form>
      </div>
    );
};

Holding.propTypes = {
   onHoldingSubmit: PropTypes.func,
   onCancelSubmit: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};
export default injectIntl(Holding);
